import {
    DEALERGETUSERMASTERLIST_SUCCESS,
    DEALERGETUSERMASTERLIST_FAILED,
    RESET_DEALERGETUSERMASTERLIST,
    LOADING_DEALERGETUSERMASTERLIST,
    NETWORK_ERROR_DEALERGETUSERMASTERLIST
} from "../types/index";
import { dealerServices } from "../../config/axios";

const resetDealerGetUserMasterList = () => {
    return { type: RESET_DEALERGETUSERMASTERLIST };
};

const dealerGetUserMasterList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERGETUSERMASTERLIST });
    await dealerServices
        .post("getUserMasterList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerGetUserMasterListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerGetUserMasterListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERGETUSERMASTERLIST,
                payload: err
            });
        });
};
function dealerGetUserMasterListsuccess(data) {
    return {
        type: DEALERGETUSERMASTERLIST_SUCCESS,
        payload: data
    };
}
function dealerGetUserMasterListFailed(data) {
    return {
        type: DEALERGETUSERMASTERLIST_FAILED,
        payload: data
    };
}

export { resetDealerGetUserMasterList, dealerGetUserMasterList };
